import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl overflow-hidden">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
            <div className="p-8 md:p-12 flex flex-col justify-center">
              <span className="inline-block px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-semibold mb-4 w-fit whitespace-nowrap">
                移动端专属
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-2">{appData.title}</h2>
              <p className="text-background-50/80 text-sm mb-4">{appData.subtitle}</p>
              <p className="text-background-50/70 text-sm leading-relaxed mb-6">{appData.description}</p>
              <div className="flex flex-wrap gap-2 mb-6">
                {appData.features.map((feat, idx) => (
                  <span key={idx} className="px-3 py-1.5 bg-background-50/15 text-background-50 rounded-full text-xs font-medium whitespace-nowrap">
                    {feat}
                  </span>
                ))}
              </div>
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                <a
                  href="#"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-50 text-primary-600 font-semibold rounded-full hover:bg-background-100 transition-all text-sm whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-line text-lg"></i>
                  iOS 下载
                </a>
                <a
                  href="#"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-50/15 text-background-50 font-medium rounded-full border border-background-50/30 hover:bg-background-50/25 transition-all text-sm whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-line text-lg"></i>
                  Android 下载
                </a>
              </div>
            </div>
            <div className="hidden md:flex items-end justify-center">
              <img
                src={appData.imageUrl}
                alt="91在线视频APP"
                className="max-h-[380px] object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}